import { StrictMode } from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { ThemeProvider } from "next-themes";
import { queryClient, persister } from "./queryClient";
import { routeTree } from "./routeTree.gen";
import { ThemedToaster } from "@shared/components/layout/ThemedToaster";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { defaultShouldDehydrateQuery } from "@tanstack/react-query";
import { isUnpersistedQueryKey } from "@shared/queries/lookupStaleTimes";
import 'react-international-phone/style.css';
import { GoogleMapsProvider } from "@shared/providers/googlemaps";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        storageKey="neztrack-theme"
        disableTransitionOnChange
      >
        <GoogleMapsProvider>
          <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{
              persister,
              // Bumped when ["session", "permissions"] became unpersisted, so copies already in localStorage are dropped.
              buster: "lookups-v4",
              dehydrateOptions: {
                shouldDehydrateQuery: (query) =>
                  defaultShouldDehydrateQuery(query) && !isUnpersistedQueryKey(query.queryKey),
                shouldDehydrateMutation: () => false,
              },
            }}
          >
            <RouterProvider router={router} />
            <ThemedToaster />
          </PersistQueryClientProvider>
        </GoogleMapsProvider>
      </ThemeProvider>
    </StrictMode>
  );
}
